import { apiFetch } from '../../utils/apiFetch';

export const createWalletSlice = (set, get) => ({
  wallet: null,          // { balance, currency, transactions[] }
  wallet_loading: false,
  wallet_error: null,

  // GET /api/v1/customer/wallet
  fetchWallet: async () => {
    set({ wallet_loading: true, wallet_error: null });
    try {
      const json = await apiFetch('api/v1/customer/wallet');
      const data = json.data ?? json;
      set({
        wallet: {
          balance:      parseFloat(data.balance ?? data.wallet_balance ?? 0),
          currency:     data.currency ?? 'INR',
          transactions: Array.isArray(data.transactions) ? data.transactions : [],
        },
        wallet_loading: false,
      });
    } catch (err) {
      set({ wallet_error: err.message, wallet_loading: false });
    }
  },
});
